import React from "react";
import { Avatar, Typography } from "antd";
import { StarTwoTone, UserOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

interface AvatarCardProps {
  name: string;
  avatar?: string;
  subtitle?: string;
  role?: string;
  size?: number;
}

export default function AvatarCard({
  name,
  avatar,
  subtitle,
  role,
  size = 120,
}: AvatarCardProps) {
  return (
    <div style={{ textAlign: "center" }}>
      <Avatar
        size={size}
        src={avatar || null}
        icon={<UserOutlined />}
        style={{ backgroundColor: "#d9d9d9" }}
      />

      {subtitle && (
        <Text style={{ display: "block", marginTop: 12, fontSize: 16 }}>
          {subtitle}
        </Text>
      )}

      <Title level={5} style={{ margin: subtitle ? "4px 0 0" : "16px 0 0" }}>
        {name}
      </Title>

      {role && (
        <Text
          type="secondary"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            marginTop: 8,
          }}
          className="capitalize-first-letter"
        >
          <StarTwoTone style={{ fontSize: 24 }} twoToneColor="#faad14" />
          {role}
        </Text>
      )}
    </div>
  );
}
